import { render } from "./DataPrivacy.vue?vue&type=template&id=0afe5155&scoped=true"
const script = {}

import "./DataPrivacy.vue?vue&type=style&index=0&id=0afe5155&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0afe5155"]])

export default __exports__